"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stopDictate;
exports.STOP_DICTATE = void 0;
var STOP_DICTATE = 'WEB_CHAT/STOP_DICTATE';
exports.STOP_DICTATE = STOP_DICTATE;

function stopDictate() {
  return {
    type: STOP_DICTATE
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3N0b3BEaWN0YXRlLmpzIl0sIm5hbWVzIjpbIlNUT1BfRElDVEFURSIsInN0b3BEaWN0YXRlIiwidHlwZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLFlBQVksR0FBRyx1QkFBckI7OztBQUVlLFNBQVNDLFdBQVQsR0FBdUI7QUFDcEMsU0FBTztBQUFFQyxJQUFBQSxJQUFJLEVBQUVGO0FBQVIsR0FBUDtBQUNEIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU1RPUF9ESUNUQVRFID0gJ1dFQl9DSEFUL1NUT1BfRElDVEFURSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHN0b3BEaWN0YXRlKCkge1xuICByZXR1cm4geyB0eXBlOiBTVE9QX0RJQ1RBVEUgfTtcbn1cblxuZXhwb3J0IHsgU1RPUF9ESUNUQVRFIH07XG4iXX0=